import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    loading: false
    // 请求数据时加载状态loading
}

const mutations = {
    // 请求数据时loading
    showLoading(state) {
        state.loading = true
    },
    hideLoading(state) {
        state.loading = false
    }
}


export default {
    state,
    mutations
}